import { render, staticRenderFns } from "./CarouselType.vue?vue&type=template&id=5d005750&scoped=true"
import script from "./CarouselType.vue?vue&type=script&lang=ts"
export * from "./CarouselType.vue?vue&type=script&lang=ts"
import style0 from "./CarouselType.vue?vue&type=style&index=0&id=5d005750&prod&scoped=true&lang=scss"
import style1 from "./CarouselType.vue?vue&type=style&index=1&id=5d005750&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d005750",
  null
  
)

export default component.exports